// extracted by mini-css-extract-plugin
var _1 = "UserProfileTabs-moduletab__Ca48E Tab-moduleTab__yRe6s";
var _2 = "UserProfileTabs-moduletabsWrapper__Dpymi TabScrollList-modulewrapper__zIrvw";
export { _1 as "tab", _2 as "tabsWrapper" }
